import { render, staticRenderFns } from "./msActionIconButton.vue?vue&type=template&id=542a27e1&scoped=true"
import script from "./msActionIconButton.vue?vue&type=script&lang=js"
export * from "./msActionIconButton.vue?vue&type=script&lang=js"
import style0 from "./msActionIconButton.vue?vue&type=style&index=0&id=542a27e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a27e1",
  null
  
)

export default component.exports